<template>
  <v-container>
    <h2>Usuarios</h2>
    <br />
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <h3>¿Cómo editar un usuario?</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <p>
            Un usuario está conformado por un nombre y un rol, el cual define
            los permisos que tiene dentro del sistema.
          </p>
          <p>
            Debido a que se utiliza una cuenta de Gmail para iniciar sesión, no
            es posible cambiar el nombre de un usuario.
          </p>
          <p>Sin embargo, es posible cambiar su rol.</p>
          <br />

          <br />

          Una vez que se visualice la tabla de Usuarios, identificar el usuario
          que se quiere editar y hacer click en el ícono
          <v-btn class="mx-2" icon> <v-icon dark>mdi-pencil</v-icon> </v-btn>
          en la columna llamada "Editar".

          <v-container class="d-flex justify-center mb-6">
            <v-img
              contain
              max-height="550"
              max-width="700"
              src="../assets/UserEditPointer.png"
            ></v-img>
          </v-container>
          <br />
          <p>
            <strong>Nota:</strong>Solo el administrador es capaz de ver a los
            usuarios del sistema y no es capaz de cambiar su propio rol.
          </p>
          <br />

          Al hacer click, se desplegará una ventana donde se podrá visualizar
          toda la información relacionada al Usuario.

          <v-container class="d-flex justify-center mb-6">
            <v-img
              contain
              max-height="550"
              max-width="600"
              src="../assets/EditUserModal.png"
            ></v-img>
          </v-container>
          <br />

          Hacer click en el campo de "Rol", donde se desplegará una lista de los
          roles disponibles.

          <v-container class="d-flex justify-center mb-6">
            <v-img
              contain
              max-height="550"
              max-width="1000"
              src="../assets/EditUserRoleDropdown.png"
            ></v-img>
          </v-container>

          <br />

          Una vez que se haga el cambio, hacer click en "Guardar".
          <v-container class="d-flex justify-center mb-6">
            <v-img
              contain
              max-height="550"
              max-width="1000"
              src="../assets/EditUserSavePointer.png"
            ></v-img>
          </v-container>
          <br />

          Se desplegará una alerta en pantalla notificando que la actualización
          de datos ha sido exitosa.

          <v-container class="d-flex justify-center mb-6">
            <v-img
              contain
              max-height="550"
              max-width="1000"
              src="../assets/EditUserSuccessAlert.png"
            ></v-img>
          </v-container>
          <br />
        </v-expansion-panel-content>
      </v-expansion-panel>

      <br />
      <v-expansion-panel>
        <v-expansion-panel-header>
          <h3>¿Cómo eliminar un usuario?</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <br />

          Una vez que se visualice la tabla de Usuarios, identificar al usuario
          que se quiere eliminar y hacer click en el ícono
          <v-btn class="mx-2" icon> <v-icon dark>mdi-delete</v-icon> </v-btn>
          en la columna llamada "Borrar".

          <v-container class="d-flex justify-center mb-6">
            <v-img
              contain
              max-height="550"
              max-width="1000"
              src="../assets/DeleteUserButtonPointer.png"
            ></v-img>
          </v-container>
          <br />
          <br />

          Se abrirá una ventana de confirmación mostrando el nombre y el rol del
          Usuario que se desea borrar. Para continuar, hacer click en "Eliminar.

          <v-container class="d-flex justify-center mb-6">
            <v-img
              justify
              contain
              max-height="550"
              max-width="600"
              src="../assets/DeleteUserPointer.png"
            ></v-img>
          </v-container>
          <br />

          Se desplegará una alerta en pantalla notificando que la persona ha
          sido eliminada exitosamente.

          <v-container class="d-flex justify-center mb-6">
            <v-img
              contain
              max-height="550"
              max-width="1000"
              src="../assets/DeleteUserSuccessAlert.png"
            ></v-img>
          </v-container>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
export default {
  name: "DocsUsers",

  data: () => ({}),
};
</script>
